import { css } from 'linaria';

export const stickyPanelWrapper = css`
  position: sticky;
  position: -webkit-sticky;
  display: flex;
  justify-content: center;
  height: var(--pdp-sticky-panel-height, 64px);
  background-color: var(--background-primary);
`;

export const stickyPanelMediumWrapper = css`
  overflow-x: auto;
  position: sticky;
  position: -webkit-sticky;
  display: flex;
  justify-content: space-between;
  height: var(--pdp-sticky-panel-height, 64px);
  background-color: var(--background-primary);
`;

export const stickyPanelTabletWrapper = css`
  overflow-x: auto;
  position: relative;
  display: flex;
  justify-content: center;
  height: var(--pdp-sticky-panel-height, 64px);
  background-color: var(--background-primary);
`;

export const stickyPanelInnerWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  &.mobile {
    width: 100%;
  }

  &.tablet {
    width: 100%;
  }

  &.medium {
    width: auto;
  }

  &.large {
    width: 1180px;
  }
`;

export const mobileProductWrapper = css`
  display: block;
  width: 100%;
`;

export const tabletProductWrapper = css`
  display: block;
  width: 100%;
`;
export const mediumPlusProductVisible = css`
  width: 362px;
  opacity: 1;
  pointer-events: auto;
  transition: opacity 300ms ease-in;
`;

export const mediumPlusProductHidden = css`
  width: 0;
  opacity: 0;
  pointer-events: none;
`;

export const stickyProductWrapper = css`
  width: 100%;
  height: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (--from-desktop) {
    width: 578px;
  }

  @media (--from-largeDesktop) {
    width: 694px;
  }
`;

export const hidden = css`
  display: none;
`;

export const invisible = css`
  height: 0;
  visibility: hidden;
`;
